<script>
    import { partition } from 'lodash';
    import MediaPlayer from './MediaPlayer.svelte';
    export let images;
    export let onRestart;
    export let onFinalSceneImageClick;

    const  [horizontalImages, verticalImages] = partition(images, ['isHorizontal', true]);
</script>

<div class="final-scene">
    <div class="vertical-images">
        {#each verticalImages as image}
            <img
                class="vertical-card card"
                src={image.frontImgPath}
                alt=""
                on:mousedown={() => onFinalSceneImageClick(image.id)}
            />
        {/each}
    </div>
    <div class="horizontal-images">
        {#each horizontalImages as image}
            <img
                class="horizontal-card card"
                src={image.frontImgPath}
                alt=""
                on:mousedown={() => onFinalSceneImageClick(image.id)}
            />
        {/each}
    </div>
    <MediaPlayer {onRestart}/>
</div>

<style>
    .final-scene {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .vertical-images {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        width: 100%;
        padding-top: 5px;
    }
    .horizontal-images {
        display: flex;
        justify-content: space-evenly;
        align-items: flex-start;
        width: 86%;
    }
    .horizontal-images > :nth-child(2n-1) {
        width: 13%;
    }
    .vertical-card {
        width: 12%;
        height: intrinsic;
    }
    .horizontal-card {
        width: 14vw;
        transform: rotate(90deg);
    }
    .card {
        cursor: pointer;
        border-radius: 8%;
        margin: 2px 5px;
    }
</style>